import { Component,OnInit, ViewChild, ElementRef } from '@angular/core';
import { ChartType, ChartOptions,ChartDataSets, RadialChartOptions } from 'chart.js';
import { SingleDataSet, Label, monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip } from 'ng2-charts';
import {ReportserviceService}  from '../../reportservice.service';
import { DatePipe } from '@angular/common';
import { MatTableDataSource } from '@angular/material/table';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { PatientDetailModel } from 'app/opdvisits/Models/patient_details.model';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { ExportService } from 'app/reports/services/export.service';
import {OptListByDate,OptListByMonth} from './optdata';
import { AuthService } from 'app/auth/auth.service';



@Component({
  selector: 'app-opd-date-wise-report',
  templateUrl: './opd-date-wise-report.component.html',
  styleUrls: ['./opd-date-wise-report.component.scss']
})
export class OpdDateWiseReportComponent implements OnInit {
 


public link: string = 'https://medium.com/@garfunkel61/angular-simplest-solution-for-social-sharing-feature-6f00d5d99c5e';  
showspinner = false;
patientcount;
dataSource = new MatTableDataSource<PatientDetailModel>();
startdate;
enddate;
pname = "";
pageHeading:any;

public OpdDataArray:any =[];
isShowDivIf = false;
isGraph = false;
ismonthly = false;
isgrapandData = false;
isdatewise = false;
isnewcolor =false;
public setcharttype;
public senddataArray:any = [];
public serchdata:any =[];
public pieChartDataArray = [];
public toDaysDate:any;
public Labels =['OPT Date','Total','Fresh','Review','Male','Female','Cross Reff',
'Dillated','Walk In','With Appt','TAT'];

public pieChartOptions: ChartOptions = {
  responsive: true,
};

public pieChartData: ChartDataSets[] = [
   { data: [48,70,82,57,39,66,75,88,49,71,89], label: 'OPD DateWise Analysis', },
  // { data: [10,20,30,30,40,39,28,36,39,41,29], label: 'OPD DateWise Analysis', }
];
public pieChartLabels: Label[] = this.Labels;
public pieChartType: ChartType = 'pie';
public pieChartLegend = true;
public pieChartPlugins = [];



constructor(public reportservice:ReportserviceService,public dbservice:DashboardService, 
  public opdvisitService: OpdVisitService, public authService :AuthService,
  private datePipe: DatePipe,private exportdata:ExportService) {
    monkeyPatchChartJsTooltip();
     monkeyPatchChartJsLegend();
     this.pageHeading = 'OPD Date Wise Reports'


 }

 ngOnInit(): void {
 
  this.toDaysDate = this.authService.getServerDate;
   this.toDaysDate = this.datePipe.transform(this.toDaysDate, "yyyy-MM-dd");
   console.log(this.toDaysDate);
  
   this.reportservice.get_opd_sdate_edate(this.toDaysDate, this.toDaysDate).
   subscribe(data => this.success_pat_sdate_edate(data), err => this.failed_pat_sdate_edate(err));
  //  this.getpichartbydates(this.toDaysDate);
  //  this.pieChartType ='bar';
//  var type ='bar';
//   this.setgraptype(type);

 
}
 setgraptype(type){
  console.log(type);
  this.pieChartType = type;
 
 }

//  setgraptype(type){
//   console.log(type)
//  if(type === 'bar'){
//   this.pieChartType = 'bar';
//   this.pieChartData =[
//    { data: [48,70,82,57,39,66,75,88,49,71,89], label: 'OPD Monthly Analysis' }
//  ];

//  }
//  else  if(type === 'line'){
//   this.pieChartType = 'line';
//   this.pieChartData =[
//    { data: [48,70,82,57,39,66,75,88,49,71,89], label: 'OPD Monthly Analysis' }
//  ];

//  }
//  else  if(type === 'pie'){
//   this.pieChartType = 'pie';
//   this.pieChartData =[
//    { data: [48,70,82,57,39,66,75,88,49,71,89], label: 'OPD Monthly Analysis' }
//  ];

//  }



// }

toggleDisplayDivIf() {
  this.isShowDivIf = !this.isShowDivIf;
}

public onButtonClick(event: MouseEvent): void {
  this.isgrapandData = !this.isgrapandData;
}

togglegraphIf() {
  this.isGraph = !this.isGraph;
}

togglegraphDataIf() {
  this.isgrapandData = !this.isgrapandData;
}

getpichartbydates(date){

  this.reportservice.get_opd_piechart_sdate_edate(date, date).subscribe(data=>{
    console.log('graphs',data);
    var  ChartData = data;
    for (let i = 0; i < ChartData.length; i++) {
    const element = ChartData[i];
    this.pieChartDataArray.push(element.total);
    this.pieChartDataArray.push(element.fresh);
    this.pieChartDataArray.push(element.review);
    this.pieChartDataArray.push(element.male);
    this.pieChartDataArray.push(element.female);
    this.pieChartDataArray.push(element.crossReff);
    this.pieChartDataArray.push(element.dilated);
    this.pieChartDataArray.push(element.walkIn);
    this.pieChartDataArray.push(element.withAppt);
    this.pieChartDataArray.push(element.tat);

    console.log('piegraph',this.pieChartDataArray);
    this.pieChartData =[
       { data: [date,element.total,element.fresh,element.review,element.male,element.female,element.crossReff,
        element.dilated,  element.walkIn,element.withAppt,element.tat], label: 'OPD DateWise Analysis', },
      // { data: [10,20,30,30,40,39,28,36,39,41,29], label: 'OPD DateWise Analysis', }
    ];
    //  this.pieChartDataArray;
  }
  })
}

togglemonthelyIf(data) {
  // console.log(data);
  let sdate = this.datePipe.transform(this.startdate, "yyyy-MM-dd");
  let edate = this.datePipe.transform(this.enddate, "yyyy-MM-dd");
  if(data === 'yes'){
    this.ismonthly = !this.ismonthly;
   
    this.reportservice.get_opd_monthly_sdate_edate(sdate, edate).
    subscribe(data => {
      // console.log('monthly array',data);
      this.OpdDataArray = data;
      // console.log('monthly', this.OpdDataArray);
    });
    // this.dummyaData =  OptListByMonth;
    this.Labels =['OPT Month','Total','Fresh','Review','Male','Female','Cross Reff',
  'Dillated','Walk In','With Appt','TAT'];
  this.pieChartData =[
    { data: [48,70,82,57,39,66,75,88,49,71,89], label: 'OPD Monthly Analysis' }
  ];
  this.pageHeading = 'OPD Month Wise Reports'
  
   }
  else{
    this.ismonthly = !this.ismonthly;
    // this.dummyaData =  OptListByDate;
 
    this.reportservice.get_opd_sdate_edate(sdate,edate).
    subscribe(data => {
      console.log('date array',data);
      this.OpdDataArray = data;

    });
    this.Labels =['OPT Date','Total','Fresh','Review','Male','Female','Cross Reff',
    'Dillated','Walk In','With Appt','TAT'];
    this.pieChartData =[
      { data: [8,10,8,7,9,6,5,8,9,11,9], label: 'OPD DateWise Analysis', }
    ];
    this.pageHeading = 'OPD Date Wise Reports'
    
  }

  
}
 



get_records_between_two_dates(){
 

  let sdate = this.datePipe.transform(this.startdate, "yyyy-MM-dd");
  let edate = this.datePipe.transform(this.enddate, "yyyy-MM-dd");
  console.log(sdate,edate)
  this.getpichartbydates(sdate)

 this.reportservice.get_opd_sdate_edate(sdate,edate).
 subscribe(data => this.success_pat_sdate_edate(data), err => this.failed_pat_sdate_edate(err));
}

success_pat_sdate_edate(data){
  console.log(data);
  
this.OpdDataArray = data;
}
failed_pat_sdate_edate(err){
this.showspinner = false;
}




exportexcel(): void 
  {
     let element = document.getElementById('content'); 
     this.exportdata.exportxcel(element);
   }


public openPDF():void {
  this.exportdata.open_loader_Dialogtwo();
  let DATA = document.getElementById('content');
  this.exportdata.downloadAsPDF(DATA,'OPD Date Wise Reports');
      
}
public printPDF(): void {
      this.exportdata.printpDFData(); 
}
printComponent(cmpName) {
  let printContents = document.getElementById(cmpName).innerHTML;
  this.exportdata.printData(printContents);
  
}





}
